import axios from "axios";

// PATHS
const RA_DETAIL = `/network/ra/details`;
const GET_ATTACHMENT_LIST = '/network/ra/getRaDocuments';
const DOWNLOAD_ATTACHMENT = '/network/ra/getBase64';
const RA_NOTES = '/network/ra/note-list';
const RA_ADD_NOTE = '/network/ra/add-note';
const RA_CUSTOMER_REPORTS_GET_IMAGES_BY_POSITION = '/network/customer_report/{id}/images/{position}';
const RA_CUSTOMER_REPORTS_UPDATE_STATUS = '/network/customer_report/updateStatus';

const fetchRaDetail: any = async (req: any) => {
    const response = await axios.post(RA_DETAIL, req);
    return response.data;
}

const fetchAttachmentsInfo: any = async (req: any) => {
    const response = await axios.post(GET_ATTACHMENT_LIST, req);
    return response.data;
}

const downloadAttachment: any = async (req: any) => {
    const response = await axios.post(DOWNLOAD_ATTACHMENT, req);
    return response.data;
}

const fetchRaNotes: any = async (reqParams: {idRentalAgreement: string}) => {
    const response = await axios.get(RA_NOTES, { params: reqParams });
    return response.data;
}

const addRaNote: any = async (req: {idRentalAgreement: string, body: string}) => {
    const response = await axios.post(RA_ADD_NOTE, req);
    return response.data;
}

const getImageByPosition: any = async (id: string, position: string) => {

    console.log("getImageByPosition id:", id);
    console.log("getImageByPosition position:", position);

    const url = RA_CUSTOMER_REPORTS_GET_IMAGES_BY_POSITION
        .replace('{id}', id)
        .replace('{position}', position);

    const response = await axios.get(url);
    return response.data;
}

const updateCRStatus: any = async (req: {ra_id: string, status: string}) => {
    const response = await axios.post(RA_CUSTOMER_REPORTS_UPDATE_STATUS, req);
    return response.data;
}

export {
    fetchRaDetail,
    fetchAttachmentsInfo,
    downloadAttachment,
    fetchRaNotes,
    addRaNote,
    getImageByPosition,
    updateCRStatus
}